export function updateZIndex(oldZIndex, newZIndex, object) {
  if (object.parentNode) {
    var parentEntity = object.parentNode;
    var parentRenderable = parentEntity.renderable;
    var parentSortable = parentEntity.sortable;

    if (parentRenderable) {
      parentRenderable.dirty = true;
    } // need re-sort on parent


    if (parentSortable) {
      parentSortable.dirty = true;
    }
  }
}